import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faStarHalfAlt } from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarEmpty } from "@fortawesome/free-regular-svg-icons";

const RatingStars = ({ rating }) => {
    // rating could be 4.5, 3.2, etc.
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.25 && rating % 1 < 0.75; // half star threshold
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    return (
        <span
            className="ms-auto d-inline-flex align-items-center justify-content-center px-2 rounded"
            style={{
                backgroundColor: "#fff7e6", // soft yellow background
                border: "1px solid #f4b722",
                borderRadius: "6px",
                fontSize: "13px",
                fontWeight: "600",
                color: "#000",
                minWidth: "45px",
            }}
        >
            <FontAwesomeIcon icon={faStar} className="text-warning me-1" />
            {rating ? rating.toFixed(1) : "0.0"}
        </span>

    );
};

export default RatingStars;
